import { render, staticRenderFns } from "./CreateDashboard.vue?vue&type=template&id=129e35b2"
import script from "./CreateDashboard.vue?vue&type=script&lang=js"
export * from "./CreateDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports